var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimer = function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 0c-13.3 0-24 10.7-24 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V49.4C383.6 61.3 464 149.2 464 256c0 114.9-93.1 208-208 208S48 370.9 48 256c0-43.3 13.2-83.5 35.8-116.8 7.5-11 4.6-25.9-6.4-33.3s-25.9-4.6-33.3 6.4C16.3 153.2 0 202.7 0 256c0 141.4 114.6 256 256 256s256-114.6 256-256S397.4 0 256 0m-63 159c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l80 80c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9z"
  })));
};
export default SvgTimer;